<template>
  <SoWidget no-padding>
    <div class="w-100 overflow-x-auto">
      <div class="d-flex justify-space-between">
        <CurrentPaymentsWidget />
        <SoDivider vertical class="mx-1 h-auto" />
        <SuggestedPaymentsWidget />
        <SoDivider vertical class="mx-1 h-auto" />
        <BalanceAndRefundWidget />
      </div>
    </div>
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoDivider from "@/components/SoDivider.vue"
  import CurrentPaymentsWidget from "./CurrentPaymentsWidget.vue"
  import SuggestedPaymentsWidget from "./SuggestedPaymentsWidget.vue"
  import BalanceAndRefundWidget from "./BalanceAndRefundWidget.vue"

  export default defineComponent({
    components: {
      SoWidget,
      SoDivider,
      CurrentPaymentsWidget,
      SuggestedPaymentsWidget,
      BalanceAndRefundWidget,
    },
  })
</script>
